import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ValueBridgeGraphData } from './sb-value-bridge.model';
import { Currency } from '../../components/currency-selector/currency-country-codes';
import { AppConfigQuery } from 'src/app/core/state/app-config/app-config.query';
import { Cacheable } from 'ts-cacheable';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ValueBridgeService {
    constructor(private http: HttpClient, private _config: AppConfigQuery) {}

    /** get
     * @description Fetches value bridge data based on the provided parameters, and caches the result based on passed parameters for 5 minutes.
     * @param params The query parameters for the request.
     * @returns An Observable of ValueBridgeGraphData.
     */
    @Cacheable({
        cacheHasher: (params) => {
            return JSON.stringify(params[0]);
        },
        maxAge: 1000 * 60 * 5,
        maxCacheCount: 5
    })
    get(params: {
        baseCurrency: Currency;
        startDate: string;
        endDate: string;
        chartType: 'portfolio' | 'asset_type' | string;
        accountIds: number[];
        group?: string;
    }): Observable<ValueBridgeGraphData> {
        let queryParams = new HttpParams()
            .set('base_currency', params.baseCurrency)
            .set('start_date', params.startDate)
            .set('end_date', params.endDate)
            .set('account_ids', params.accountIds.join(','));

        let resourcePath = `v1/value-bridge/${params.chartType.replace('_', '-')}`;
        if (params.group && params.group.trim() !== '') {
            // just to include the '/group' keyword in the path
            resourcePath += `/group`;
            //both asset-type and asset_type are used in the url, we are fixing this conflict here
            queryParams = queryParams.set(params.chartType, params.group.trim());
        }

        const url = `${this._config.appConfig.clickhouseBaseUrl}/${resourcePath}`;
        return this.http
            .get<ValueBridgeGraphData>(url, {
                params: queryParams
            })
            .pipe(
                map((data) => {
                    // TODO: this should be handled on the backend, i.e. when there are no changes in the data, the graph should be empty
                    const noChange = !data.graph.some((item) => item.value !== 0);
                    if (noChange) {
                        return { ...data, graph: [] };
                    }
                    return data;
                })
            );
    }
}
